import React from 'react';
import classnames from 'classnames';
import { Button, Icon } from '@fiverr-private/fit';
import { Dropdown, Menu } from '@fiverr-private/orca';
import { s_ellipsis } from '@fiverr-private/icons';
import { getWindow } from '../../../../utils';

import styles from './index.module.scss';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const T_PREFIX = 'freelancer_page.dots_menu';

/** @type {import('./index').DotsMenuButton} */
export const DotsMenuButton = ({
    className,
    inStickyHeader,
    isLoggedIn,
    position = Dropdown.POSITIONS.RIGHT,

    source,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    user,
}) => {
    const menuItems = [];

    // README: Now we return `null` and do not render this button, after remove "Report" option.
    // In while `menuItems` will be filled in by other options.
    if (!menuItems.length) {
        return null;
    }

    const buttonEl = (
        <span className={classnames(styles.dotsMenuButtonWrapper, className)} data-testId="dots-menu-button">
            <Button className={styles.controlButton} fill={Button.FILLS.GHOST} color={Button.COLORS.LIGHT_GREY}>
                <Icon>{s_ellipsis}</Icon>
            </Button>
        </span>
    );

    if (!isLoggedIn) {
        return React.cloneElement(buttonEl, {
            onClick: () => getWindow()?.openSignUpModal && getWindow()?.openSignUpModal({}, { source }),
        });
    }

    return (
        <Dropdown
            className={classnames(styles.dropdownMenuWrapper, { [styles.inStickyHeader]: inStickyHeader })}
            position={position}
            menu={<Menu className={styles.menuWrapper}>{menuItems}</Menu>}
        >
            {buttonEl}
        </Dropdown>
    );
};
